import { ENTITLED_THIRDPARTY_APPS_API } from 'constants/AppConstants'; // #genai
import { getTokenFromUrl } from 'utils/auth.utils'; // #genai

/** GET /v1/entitled-thirdparty-apps */ // #genai
const getEntitledThirdPartyApps = async () => {
  try {
    const token = getTokenFromUrl();
    const response = await fetch(ENTITLED_THIRDPARTY_APPS_API, {
      method: 'GET',
      headers: { Authorization: `Bearer ${token}` },
    });

    const json = await response.json();

    if (response.status !== 200) return { ok: false, json };

    return { ok: true, json };
  } catch (error) {
    return { ok: false, error };
  }
};

export default getEntitledThirdPartyApps;
